import React from 'react';
import styled from 'styled-components/macro';
import vw from 'rpf/un/vw';
import Modal from 'components/Modal';
import autobg from 'autobg.macro';

const Wrap = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: ${vw(690)};
  height: ${vw(891)};
  background-color: #ffffff;
  border-radius: ${vw(20)};
`;

const Title = styled.div`
  ${autobg('assets/img/home/protocol_title.png')}
  margin-top: ${vw(61)};
`;

const Content = styled.div`
  width: ${vw(630)};
  height: ${vw(619)};
  margin-top: ${vw(50)};
  overflow-y: auto;
`;

const Btn = styled.div`
  ${autobg('assets/img/home/btn_protocol.png')};
  margin-top: ${vw(30)};
`;

const ProtocolModal = ({ open, onClose }) => {
  return (
    <Modal open={open}>
      <Wrap>
        <Title />
        <Content className="scrollable">
          <h3>中国银行“中银跨境GO”活动隐私保护协议</h3>
          <p>
            《中国银行“中银跨境GO”活动隐私保护协议》是活动主办方中国银行股份有限公司与用户（以下简称“您”）所订立的有效合约。请仔细阅读本协议内容，如您对本协议内容或页面提示信息有疑问，请勿进行下一步操作。您可通过活动客服电话95566进行咨询，以便我们为您解释和说明。如您通过页面点击确认本协议即表示您已同意本协议。
          </p>
          <h4>一、信息收集</h4>
          <p>
            为确保您顺利参与本次活动，活动主办方会收集您在使用服务过程中主动输入而产生的身份证后四位、手机号码信息。
          </p>
          <h4>二、信息使用</h4>
          <p>
            为了使您知悉活动进度、领取专属权益等，活动主办方会视情况向您发送活动通知、权益领取提醒、返现到账通知等。如您符合活动参与标准，可通过中国银行微银行低价换购亚马逊优惠券，如因您未在活动期间及时领取权益，视为您放弃相应权益。{' '}
          </p>
          <h4>三、信息保护</h4>
          <p>
            （一）活动主办方已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权的访问、公开披露、使用、修改、损坏或丢失。活动主办方会采取一切合理可行的措施，保护您的个人信息。
          </p>
          <p>
            （二）活动主办方会采取一切合理可行的措施，确保不收集无关的个人信息。
          </p>
          <p>
            （三）如发生个人信息安全事件，活动主办方将按照法律法规和监管规定，及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，或采取合理、有效的方式发布公告。同时，活动主办方还将依据法律法规和监管规定，上报个人信息安全事件处置情况。
          </p>
          <h4>四、信息授权</h4>
          <p>
            为保障活动技术支持，您同意第三方采集您的手机号信息加密传递给活动主办方。活动主办方将要求第三方严格遵守相关法律法规与监管要求，依法使用您的信息，并对您的信息保密。
          </p>
        </Content>
        <Btn onClick={onClose} />
      </Wrap>
    </Modal>
  );
};

export default ProtocolModal;
